import React from "react";
import ButtonLoader from "../buttonLoader";
import { Modal } from "antd";

const DeletConfirmation = ({
  handleDelete,
  deleteModal,
  setDeleteModal,
  isLoading,
  task = false,
  project = false,
}) => {
  return (
    <Modal
      className="doctor-filter-modal"
      centered
      open={deleteModal}
      onCancel={() => setDeleteModal(false)}
      width={514}
      footer={null}
      closable={false}
    >
      <div className="row pb-1">
        <div className="col-12 flex flex-col gap-3 justify-center items-center">
          <p className="font-semibold text-[20px] text-[#1E3A8A]">
            {project === true ? "Unassign" : "Delete"} This{" "}
            {task === true ? "Task" : project === true ? "Project" : "Worker"}?
          </p>
          <p className="font-normal text-base text-[#4B5563] w-[70%] text-center">
            Are you sure you want to {project === true ? "unassign" : "delete"}{" "}
            this{" "}
            {task === true ? "task" : project === true ? "project" : "worker"}?
            This action cannot be undone.
          </p>
          <div className="w-[60%] grid grid-cols-2 gap-3 mt-2">
            <button
              className="w-full h-[44px] rounded-[4px] border !border-[#F97316] font-medium text-[#F97316] text-base"
              disabled={isLoading}
              onClick={() => setDeleteModal(false)}
            >
              Cancel
            </button>
            <button
              className="w-full h-[44px] rounded-[4px] bg-[#E90C0C] font-medium text-white text-base"
              disabled={isLoading}
              onClick={handleDelete}
            >
              {!isLoading ? "Delete" : <ButtonLoader />}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeletConfirmation;
